import { httpGet, httpPost } from '../../../utils/api.utils';
import { getReleaseNotesItems, checkNewReleaseNotes, setIsFetching, confirmedReleaseNotesNotification } from '../../../constants/release-notes.settings';

const initialState = {
    releaseNotes: [],
    hasNewReleaseNotification: false,
    isLoaded: false,
    isError: false,
    isFetching: true
};
export const releaseNotesActions = {
    fetchReleaseNotesItems: () => async (dispatch, state) => {
        dispatch({
            type: setIsFetching,
            isFetching: true
        });
        var url = 'external/releasenotes/getReleaseNotes';
        var releaseNotes = await httpGet(url);

        if (releaseNotes.ok === false) {
            dispatch({
                type: setIsFetching,
                isFetching: false,
                isError: true
            });
        }
        else {
            dispatch({
                type: setIsFetching,
                isFetching: false
            });

            dispatch({
                type: getReleaseNotesItems,
                releaseNotes: releaseNotes,
                isLoaded: true
            });
        }

        if (state().releaseNotes.hasNewReleaseNotification) {
            var _url = 'external/releasenotes/releaseNotesConfirmation';
            var confirmation = await httpPost(_url);

            if (confirmation.ok === false) {
                dispatch({
                    type: setIsFetching,
                    isFetching: false,
                    isError: true
                });
            }
            else {
                dispatch({
                    type: confirmedReleaseNotesNotification,
                    confirmation: confirmation
                });
            }
        }
        return Promise.resolve(true);
    },
    releaseNotesConfirmation: () => async (dispatch) => {
        var url = 'external/releasenotes/releaseNotesConfirmation';
        var confirmation = await httpPost(url);
        if (confirmation.ok === false) {
            dispatch({
                type: setIsFetching,
                isFetching: false,
                isError: true
            });
        }
        else {
            dispatch({
                type: confirmedReleaseNotesNotification,
                confirmation: confirmation
            });
        }

        return Promise.resolve(true);
    },

    checkNewReleaseNotes: () => async (dispatch) => {
        var url = 'external/releasenotes/getNewReleaseNotes';
        var confirmation = await httpGet(url);

        if (confirmation.ok === false) {
            dispatch({
                type: setIsFetching,
                isFetching: true
            });
        }
        else {
            dispatch({
                type: checkNewReleaseNotes,
                confirmation: confirmation
            });
        }

        return Promise.resolve(true);
    }
};
export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getReleaseNotesItems:
            return {
                ...state,
                releaseNotes: action.releaseNotes,
                isLoaded: action.isLoaded
            };
        case setIsFetching:
            return {
                ...state,
                isFetching: action.isFetching,
                isError: action.isError
            };
        case confirmedReleaseNotesNotification:
            return {
                ...state,
                hasNewReleaseNotification: action.confirmation
            };
        case checkNewReleaseNotes:
            return {
                ...state,
                hasNewReleaseNotification: action.confirmation
            };
        default:
            return state;
    }
};